import React from "react";
import { Grid, Typography, Card, CardContent, Box } from "@mui/material";
import { COLORS, fontFamilyAll } from "../assets/commonComponents/COLORS";

const ServiceCard = ({ title, description, icon }) => (
  <Card
    sx={{
      height: "100%", // Ensures equal height for all cards
      width: "100%", // Ensures equal width
      boxShadow: 4,
      borderRadius: 3,
      textAlign: "left",
      transition: "0.3s",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      '&:hover': { transform: "scale(1.05)" },
    }}
  >
    <CardContent sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
      {icon}
      <Typography variant="h6" sx={{ mt: 2, fontWeight: "bold", textAlign: "left" }} fontFamily={fontFamilyAll}>
        {title}
      </Typography>
      <Typography 
        variant="body2" 
        color="text.secondary" 
        fontFamily={fontFamilyAll}
        sx={{ mt: 1, textAlign: "left", flexGrow: 1 }}
      >
        {description}
      </Typography>
    </CardContent>
  </Card>
);

const AboutUsSection = ({ image, headingText, subHeadingText, isMobile, data }) => {
  return (
    <Box sx={{ p: 4, marginLeft: isMobile ? 0 : 7 }}>
      <Typography variant="h6" color={COLORS.secondaryColor} sx={{ fontWeight: "bold", textAlign: "left" }} fontFamily={fontFamilyAll}>
        {headingText}
      </Typography>
      <Typography variant={isMobile ? "h5" : "h3"} sx={{ fontWeight: "bold", mt: 2, lineHeight: 1.3, textAlign: "left" }} fontFamily={fontFamilyAll}>
        {subHeadingText}
      </Typography>
      <Grid container spacing={5} sx={{ mt: 5, alignItems: "flex-start" }}>
        <Grid item xs={12} md={6} sx={{ display: "flex", justifyContent: "flex-start" }}>
          <Box
            component="img"
            src={image}
            alt="Team Working"
            sx={{ width: "100%", borderRadius: "12px", boxShadow: 3 }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Grid container spacing={3}>
            {data.map((service, index) => (
              <Grid item xs={12} sm={6} key={index} sx={{ display: "flex" }}>
                <ServiceCard {...service} />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AboutUsSection;
